import { memo } from 'react';
import * as stylex from '@stylexjs/stylex';
import { useSeparator } from 'react-aria';
import '../theme/Colors.stylex';
import { ColorNeutral } from '../theme/Colors.stylex';
import '../theme/Spaces.stylex';
import { Margin } from '../theme/Spaces.stylex';
export type Orientation = 'horizontal' | 'vertical';
export type Size = 'auto' | 'xsmall' | 'small' | 'medium' | 'large';
export type Spacing = 'none' | 'tiny' | 'xs' | 's' | 'm' | 'l' | 'xl';
export type SeparatorProps = {
  orientation?: Orientation;
  size?: Size;
  spacing?: Spacing;
};
const styles = {
  root: {
    "backgroundColor-kWkggS": "backgroundColor-xe58vim backgroundColor-x1qigaz0",
    "flexShrink-kmuXW": "flexShrink-x2lah0s",
    $$css: "wino-gc:src/resources/layout-and-structure/CanarySeparator.tsx:20"
  }
};

// NOTE -  renders exactly one physical pixel
const thicknessStyles = {
  vertical: {
    root: {
      "width-kzqmXN": "width-x1i1rx1s",
      "transform-k3aq6I": "transform-x1gbqge",
      $$css: "wino-gc:src/resources/layout-and-structure/CanarySeparator.tsx:32"
    }
  },
  horizontal: {
    root: {
      "height-kZKoxP": "height-xjm9jq1",
      "transform-k3aq6I": "transform-xxturw7",
      $$css: "wino-gc:src/resources/layout-and-structure/CanarySeparator.tsx:35"
    }
  }
};
const sizeStyles = {
  vertical: {
    auto: {
      "alignSelf-kSGwAc": "alignSelf-xkh2ocl",
      "height-kZKoxP": "height-xt7dq6l",
      $$css: "wino-gc:src/resources/layout-and-structure/CanarySeparator.tsx:41"
    },
    xsmall: {
      "height-kZKoxP": "height-xlup9mm",
      $$css: "wino-gc:src/resources/layout-and-structure/CanarySeparator.tsx:42"
    },
    small: {
      "height-kZKoxP": "height-x1qx5ct2",
      $$css: "wino-gc:src/resources/layout-and-structure/CanarySeparator.tsx:43"
    },
    medium: {
      "height-kZKoxP": "height-x1gnnpzl",
      $$css: "wino-gc:src/resources/layout-and-structure/CanarySeparator.tsx:44"
    },
    large: {
      "height-kZKoxP": "height-x1vqgdyp",
      $$css: "wino-gc:src/resources/layout-and-structure/CanarySeparator.tsx:45"
    }
  },
  horizontal: {
    auto: {
      "width-kzqmXN": "width-xh8yej3",
      $$css: "wino-gc:src/resources/layout-and-structure/CanarySeparator.tsx:48"
    },
    xsmall: {
      "width-kzqmXN": "width-xh8yej3",
      $$css: "wino-gc:src/resources/layout-and-structure/CanarySeparator.tsx:49"
    },
    small: {
      "width-kzqmXN": "width-xh8yej3",
      $$css: "wino-gc:src/resources/layout-and-structure/CanarySeparator.tsx:50"
    },
    medium: {
      "width-kzqmXN": "width-xh8yej3",
      $$css: "wino-gc:src/resources/layout-and-structure/CanarySeparator.tsx:51"
    },
    large: {
      "width-kzqmXN": "width-xh8yej3",
      $$css: "wino-gc:src/resources/layout-and-structure/CanarySeparator.tsx:52"
    }
  }
};
const spacingStyles = {
  vertical: {
    none: {
      $$css: "wino-gc:src/resources/layout-and-structure/CanarySeparator.tsx:58"
    },
    tiny: {
      "marginInline-kUOVxO": "marginInline-x165wqed",
      $$css: "wino-gc:src/resources/layout-and-structure/CanarySeparator.tsx:59"
    },
    xs: {
      "marginInline-kUOVxO": "marginInline-x1rc24qr",
      $$css: "wino-gc:src/resources/layout-and-structure/CanarySeparator.tsx:60"
    },
    s: {
      "marginInline-kUOVxO": "marginInline-x7yhwk6",
      $$css: "wino-gc:src/resources/layout-and-structure/CanarySeparator.tsx:61"
    },
    m: {
      "marginInline-kUOVxO": "marginInline-x1w6ra2m",
      $$css: "wino-gc:src/resources/layout-and-structure/CanarySeparator.tsx:62"
    },
    l: {
      "marginInline-kUOVxO": "marginInline-x12xotbn",
      $$css: "wino-gc:src/resources/layout-and-structure/CanarySeparator.tsx:63"
    },
    xl: {
      "marginInline-kUOVxO": "marginInline-xxn6jz4",
      $$css: "wino-gc:src/resources/layout-and-structure/CanarySeparator.tsx:64"
    }
  },
  horizontal: {
    none: {
      $$css: "wino-gc:src/resources/layout-and-structure/CanarySeparator.tsx:67"
    },
    tiny: {
      "marginBlock-kqGvvJ": "marginBlock-xjfaoln",
      $$css: "wino-gc:src/resources/layout-and-structure/CanarySeparator.tsx:68"
    },
    xs: {
      "marginBlock-kqGvvJ": "marginBlock-x1vvy9fo",
      $$css: "wino-gc:src/resources/layout-and-structure/CanarySeparator.tsx:69"
    },
    s: {
      "marginBlock-kqGvvJ": "marginBlock-x36gvm2",
      $$css: "wino-gc:src/resources/layout-and-structure/CanarySeparator.tsx:70"
    },
    m: {
      "marginBlock-kqGvvJ": "marginBlock-x1luw195",
      $$css: "wino-gc:src/resources/layout-and-structure/CanarySeparator.tsx:71"
    },
    l: {
      "marginBlock-kqGvvJ": "marginBlock-x1xl718p",
      $$css: "wino-gc:src/resources/layout-and-structure/CanarySeparator.tsx:72"
    },
    xl: {
      "marginBlock-kqGvvJ": "marginBlock-xahy4bj",
      $$css: "wino-gc:src/resources/layout-and-structure/CanarySeparator.tsx:73"
    }
  }
};
export const CanarySeparator = memo(function SeparatorComponent({
  orientation = 'vertical',
  size = 'large',
  spacing = 'xs'
}: SeparatorProps) {
  const {
    separatorProps
  } = useSeparator({
    orientation
  });
  return <div {...separatorProps} {...stylex.props(styles.root, thicknessStyles[orientation].root, sizeStyles[orientation][size], spacingStyles[orientation][spacing])} />;
});